import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import { Autoplay } from 'swiper/modules';
import axios from 'axios';
import { useEffect, useState } from 'react';

function ShopByBrand() {
    const { t } = useTranslation();
    UseScrollAnimation();


    const [data, setData] = useState([]);

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/brand");
                setData(response.data.brands)
            }
            catch (error) {
                console.error("Error Fetch Data : ", error);
            }
        }

        fetchData();
    }, [])

    return (
        <section className="relative py-[40px]">
            <div className="container">
                <div className="btmAni30002 direction-text-ar page-title mb-[20px]">
                    {t("brands")}
                </div>
                <div className="swiper-container mySwiper">
                    <Swiper
                        modules={[Autoplay]}
                        slidesPerView={3}
                        spaceBetween={10}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        style={{ height: "150px", direction: "ltr" }}
                        breakpoints={{
                            300: {
                                slidesPerView: 3,
                            },
                            370: {
                                slidesPerView: 3,
                            },
                            520: {
                                slidesPerView: 3,
                            },
                            750: {
                                slidesPerView: 4,
                            },
                            850: {
                                slidesPerView: 5,
                            },
                            1000: {
                                slidesPerView: 6,
                            },
                            1250: {
                                slidesPerView: 7,
                            },
                        }}
                        loop={true}
                    >
                        {data.map((el) => (
                            <SwiperSlide key={el.brand_id}>
                                <Link to={`/brandsProducts/${el.brand_name}`} className="flex flex-col items-center text-center">
                                    <div className='back-category flex justify-center items-center p-[20px] w-100-p h-100-p w-[150px] h-[150px] shadow-lg rounded-md overflow-hidden'>
                                        <img src={`https://laravel-api.aj-mart.com/storage/app/public/${el.brand_img}`} alt={el.brand_name} className="w-full h-auto max-w-[200px] object-contain" />
                                    </div>
                                    {/* <div>{el.brand_name}</div> */}
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="flex items-center justify-center my-[15px]">
                    <Link className="btn js-scroll fade-top" to={"/brands"}>{t("Show More")}</Link>
                </div>
            </div>
        </section >
    );
}

export default ShopByBrand;
